module.exports = __webpack_public_path__ + "brand.17565f9d.png";